export class CustomerSalesAreaModel {
    SalesOrg: string
    Division: string
    DistChannel: string
}


// WEBPACK FOOTER //
// ./src/models/sap/customersalesarea.model.ts